/**
 * Folders state atoms
 */
import { atom } from 'jotai';

import type { Folder } from '@/types/card';

// ============================================================================
// Folders State Atom
// ============================================================================

export interface FoldersState {
  data: Folder[] | undefined;
  isLoading: boolean;
  error: Error | null;
}

/** Atom holding the shared folders state - populated by init, updated by subscription */
export const foldersStateAtom = atom<FoldersState>({
  data: undefined,
  isLoading: true,
  error: null,
});
